import { TransactionTxt } from './../../_models/TransactionTxt';
import { TransactionsService } from './../../_services/Transaction/Transactions.service';
import { Component, OnInit } from '@angular/core';
import { PreloaderService } from 'src/app/_services/Preloader.service';
import { LogService } from 'src/app/_services/_LogServices/Log.service';
import { _userServicesService } from 'src/app/_services/_UserService/_userServices.service';
import { ToasterService } from 'src/app/_services/Toaster.service';
import { Device } from 'src/app/_models/Device';
import { Logs } from 'src/app/_models/Logs';
import { DeviceService } from '../../_services/_DeviceService/Device.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-GenerateTextFile',
  templateUrl: './GenerateTextFile.component.html',
  styleUrls: ['./GenerateTextFile.component.css']
})
export class GenerateTextFileComponent implements OnInit {

  public Device: Device[];
  public FromDate: any;
  public ToDate: any;
  public selectedDevice: any;
  public Logs:TransactionTxt[];

  public DatatableToggle=false;
  dtOptions: any = {};

  constructor(private SpinnerService: NgxSpinnerService,private preloader:PreloaderService,private DeviceService: DeviceService, private Trans:TransactionsService, private UserService: _userServicesService, private noti: ToasterService) { }


  ngOnInit() {
    this.preloader.hide();
    this.LoadAllDevices();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
            'copy', 'csv', 'excel', 'pdf', 'print'
        ]
      }
  }

  selectChangeHandler(event: any) {
    this.selectedDevice = event.target.value;
  }
  LoadAllDevices() {
    try {
      this.DeviceService.GetDeviceList().subscribe(
        Response => {
          this.SpinnerService.hide();
          if (Response.status == 200) {
            this.Device = Response.body;
          }
          else {
            this.noti.error("Error", Response.body);
          }

        },
        err => {
          this.SpinnerService.hide();
          this.noti.error("Error", err.error);
        }
      );
    } catch (error) {
      this.SpinnerService.hide();
      this.noti.error("Error", "Code Crashed");
    }
  }
  downloadBlob(blob, filename) {
    // Create an object URL for the blob object
    const url = URL.createObjectURL(blob);

    // Create a new anchor element
    const a = document.createElement('a');

    // Set the href and download attributes for the anchor element
    // You can optionally set other attributes like `title`, etc
    // Especially, if the anchor element will be attached to the DOM
    a.href = url;
    a.download = filename || 'download';

    // Click handler that releases the object URL after the element has been clicked
    // This is required for one-off downloads of the blob content
    const clickHandler = function() {
      setTimeout(() => {
        // Release the object URL
        URL.revokeObjectURL(url);

        // Remove the event listener from the anchor element
        this.removeEventListener('click', clickHandler);

        // Remove the anchor element from the DOM
        (this.remove && (this.remove(), 1)) ||
        (this.parentNode && this.parentNode.removeChild(this));
      }, 150);
    };
    return a;
  }
  GetAllLogs(DeviceID, FromDate, ToDate) {
    this.SpinnerService.show();
    if (DeviceID == "")
    {
      this.SpinnerService.hide();
      return  this.noti.error("Select Device Required", "Error");
    }
    if (DeviceID == "Select Device")
    {
      this.SpinnerService.hide();
      return  this.noti.error("Select Device Required", "Error");
    }
    try {
      this.DatatableToggle=false;
      this.Trans.TransactionByDevice(this.selectedDevice,FromDate,ToDate).subscribe((Response: any) => {
        this.SpinnerService.hide();
         if (Response.status == 200) {
          this.Logs=Response.body;
           if(this.Logs.length==0)
           {
            this.SpinnerService.hide();
            let Exporttxt = document.getElementById('Exporttxt');
            let divContains_P = document.getElementById('FileDiv').contains(Exporttxt);
            if(divContains_P)
       {
        $("#Exporttxt").remove();
       }
           return this.noti.error("Message", "No Data Found");
           }
           this.Logs=Response.body;
           const Text=[];
           this.Logs.forEach(item => {


             //Text.push(item.employeeID+","+item.year+"-"+item.month+"-"+item.day+" "+item.hour+":"+item.mintutes+","+item.machineId+","+item.status+"\r\n");
             Text.push(item.machineId+","+item.employeeID+","+item.status+","+item.year+"/"+item.month+"/"+item.day+","+item.hour+":"+item.mintutes+":"+item.seconds+"\r\n");


            });
           const blob = new Blob(Text, { type: 'text/plain' });
           const downloadLink = this.downloadBlob(blob, 'records.txt');

// Set the title and classnames of the link
downloadLink.title = 'Export Records as TEXT';
downloadLink.id='Exporttxt';
downloadLink.classList.add('btn-link', 'download-link','btn');

// Set the text content of the download link
downloadLink.textContent = 'Export Records';
let Exporttxt = document.getElementById('Exporttxt');
let divContains_P = document.getElementById('FileDiv').contains(Exporttxt);
       if(!divContains_P)
       {
        document.getElementById("FileDiv").appendChild(downloadLink);
       }
       else
       {
        $("#Exporttxt").remove();
        document.getElementById("FileDiv").appendChild(downloadLink);
       }
         }
         else {
           this.noti.error("Message", "Get Logs Data");
         }

      });

   } catch (error) {
    this.noti.error("Message", "Get Logs Data");
    this.SpinnerService.hide();
   }




  }

}
